import { render, staticRenderFns } from "./BlockType7.vue?vue&type=template&id=abe1fb40"
import script from "./BlockType7.vue?vue&type=script&lang=ts"
export * from "./BlockType7.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports